// extracted by css-extract-rspack-plugin
export default {"displayError":"DisplayError_displayError__e1xmQ"};